/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

const { setup, AccessToken } = window.evrythng;
const evrythng = {
  configure: options => {
    // eslint-disable-next-line fp/no-mutation
    evrythng.options = { ...evrythng.options, ...options };
    setup(evrythng.options);
    // eslint-disable-next-line fp/no-mutation
    evrythng.sdk = new AccessToken(evrythng.options.apiKey);
  },
  options: {},
  sdk: undefined,
};
export default evrythng;
